// extracted by mini-css-extract-plugin
export default {"TreeMapChart":"TreeMapChart_TreeMapChart__rt+3M","chart":"TreeMapChart_chart__fNZm1"};